import { BigDecimal } from '@vertex-protocol/client';
import { NewPill } from 'client/components/NewPill';
import {
  formatNumber,
  MarketCategory,
  PresetNumberFormatSpecifier,
  TokenIconMetadata,
  useEVMContext,
} from '@vertex-protocol/react-client';
import Image from 'next/image';
import { TableCell } from 'client/components/DataTable/cells/TableCell';
import { getArcaInstitutionalMarketDisplayName } from 'client/utils/markets/arcaInstitutionalMarkets';

interface Props {
  productId: number;
  marketName: string;
  symbol: string;
  icon: TokenIconMetadata;
  categories: Set<MarketCategory>;
  volume24h: BigDecimal | undefined;
  isNew: boolean;
}

export function TradingMarketSwitcherProductInfoCell({
  productId,
  marketName,
  symbol,
  icon,
  categories,
  volume24h,
  isNew,
}: Props) {
  const { primaryChainEnv } = useEVMContext();
  const displayName = getArcaInstitutionalMarketDisplayName({
    chainEnv: primaryChainEnv,
    productId,
    metadata: {
      symbol,
      marketName,
      marketCategories: categories,
    },
  });

  return (
    <TableCell className="gap-x-2.5">
      <Image src={icon.asset} className="h-auto w-6" alt={symbol} />
      <div className="flex flex-col items-start leading-4">
        <p className="text-text-secondary text-xs">{displayName}</p>
        <p className="text-text-tertiary text-2xs">
          {formatNumber(volume24h, {
            formatSpecifier: PresetNumberFormatSpecifier.NUMBER_INT,
          })}
        </p>
      </div>
      {isNew && <NewPill />}
    </TableCell>
  );
}
